import '../common';
import React from 'react';
import ReactDom from 'react-dom';
import QuestionBuilder from './components/QuestionBuilder';
import Messages from '../common/i18n/Messages';
import MessageDefinitions from './i18n/MessageDefinitions';
import {getLocale} from '../common/i18n/Locale';
import {IntlProvider} from 'react-intl';

function render(nodeId, {groupKey, rows = [], toggle, showAll = false, initialRows = [], messages: customMessages = {}} = {}) {
  const mountNode = document.getElementById(nodeId);
  const messages = Messages.get(MessageDefinitions, customMessages);
  const answers = initialRows.length ? initialRows : [{}];
  const questionRows = rows.length ? rows : [{}];

  questionRows.forEach( questionRow => {
    if(questionRow.questions) {
      questionRow.questions.forEach( question => {
        question.answer = null;
      });
    }
  });

  window.ignite.getAnswerService().then(answerService => {
    ReactDom.render(
      <IntlProvider locale={getLocale()} messages={messages}>
        <QuestionBuilder
          groupKey={groupKey}
          questionRows={questionRows}
          toggle={toggle}
          showAllRows={showAll}
          initialRows={answers}
          answerService={answerService}
        />
      </IntlProvider>,
      mountNode);
  });
}

function renderQuestionGroupBuilder(builderId, params) {
  render(builderId, params);
}

function unmountQuestionGroupBuilder(builderId) {
  ReactDom.unmountComponentAtNode(document.getElementById(builderId));
}

if (window.ignite) {
  window.ignite.renderQuestionGroupBuilder = renderQuestionGroupBuilder;

  window.ignite.unmountQuestionGroupBuilder = unmountQuestionGroupBuilder;
}

export {
  renderQuestionGroupBuilder,
  unmountQuestionGroupBuilder
};



/** WEBPACK FOOTER **
 ** ./src/main/js/questionGroupBuilder/index.js
 **/